import { create } from 'zustand';
import type { FeatureKey } from '@/types';
import type { Actor } from '@/types/admin';
import { adminServices, ServiceError } from '@/services';
import { can, type Permission } from '@/lib/permissions';

interface AdminSessionState {
  actor: Actor | null;
  error: ServiceError | Error | null;
  loading: boolean;
  load: () => Promise<void>;
  reset: () => void;
}

/** Client mirror of the server's `GET /api/admin/me`. Drives navigation only; the server enforces access. */
export const useAdminSession = create<AdminSessionState>((set) => ({
  actor: null,
  error: null,
  loading: true,
  load: async () => {
    set({ loading: true, error: null });
    try {
      set({ actor: await adminServices.session.me(), loading: false });
    } catch (e) {
      set({ actor: null, error: e instanceof Error ? e : new Error(String(e)), loading: false });
    }
  },
  reset: () => set({ actor: null, error: null, loading: true }),
}));

export const useCan = (perm: Permission) => useAdminSession((s) => !!s.actor && s.actor.permissions.includes(perm));
export const useAdminFeature = (key: FeatureKey) => useAdminSession((s) => !!s.actor?.tenant.features[key]);
export const canRole = can;
